// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VspOffset__textFieldContainer___jfxwg .VspOffset__textField___e1VT_ {
    width: 8rem;
}

.VspOffset__text___pAMuN {
    margin-right: 0.8rem;
}

.VspOffset__offset___ey5Wl {
    padding: 0.8rem 1.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/modules/Modals/SpeedLawsModal/components/VspOffset/VspOffset.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".textFieldContainer .textField {\n    width: 8rem;\n}\n\n.text {\n    margin-right: 0.8rem;\n}\n\n.offset {\n    padding: 0.8rem 1.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textFieldContainer": `VspOffset__textFieldContainer___jfxwg`,
	"textField": `VspOffset__textField___e1VT_`,
	"text": `VspOffset__text___pAMuN`,
	"offset": `VspOffset__offset___ey5Wl`
};
export default ___CSS_LOADER_EXPORT___;
